import { render, staticRenderFns } from "./AppRiskIdSelector.vue?vue&type=template&id=37fddb0e&scoped=true"
import script from "./AppRiskIdSelector.vue?vue&type=script&lang=js"
export * from "./AppRiskIdSelector.vue?vue&type=script&lang=js"
import style0 from "./AppRiskIdSelector.vue?vue&type=style&index=0&id=37fddb0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fddb0e",
  null
  
)

export default component.exports